import {
  gridSizeConst6,
  gridSizeMdLg12,
  gridSizeMdLg6,
  hasPermission,
  newSolicitudIngresoBenificio,
  ReglasSolicitudBeneficioEnum,
  TipoBeneficioENUM,
  useTableColumnsSolicitudIngresoProspecto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  useGetSolicitudesTutorDescuento,
  useUpdateSolicitudTutorDescuento,
} from "@/shared/actions/erp";
import {
  CustomAutocompleteArrStringNoForm,
  CustomTextArea,
  CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";
import {
  SolicitudTutorDescuento,
  SolicitudTutorDescuentoEstadoSolicitudEnum,
  SolicitudTutorDescuentoForm,
} from "@/shared/interfaces";
import { People, Person, Visibility } from "@mui/icons-material";
import { Alert, AlertTitle, Grid, Icon, Typography } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { PermissionsEnum } from "@/auth/interfaces";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArticleIcon from '@mui/icons-material/Article';
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";

const TipoBeneficio = [
  TipoBeneficioENUM.TODOS,
  TipoBeneficioENUM.AYUDA_SOCIAL,
  TipoBeneficioENUM.APLICA_GREMIO,
  TipoBeneficioENUM.FAMILIAR_DISCAPACIDAD,
  TipoBeneficioENUM.DESARROLLO_HUMANO,
  TipoBeneficioENUM.REPORTADO,
  TipoBeneficioENUM.REPORTADO_TELCO
]
export interface ITipoBeneficio {
  es_ayuda_social: boolean | null
  es_bono_humano: boolean | null
  es_tutor: boolean | null
  es_gremio: boolean | null
  es_reportado: boolean | null // score bajo
  reportado: boolean | null // reportado por isp
}

interface SolicitudIngresoProspectoSolicitudPageProps {
  estadoSolicitud: SolicitudTutorDescuentoEstadoSolicitudEnum,
  enableAction: boolean
}

const SolicitudIngresoProspectoSolicitudPage = ({
  estadoSolicitud,
  enableAction
}: SolicitudIngresoProspectoSolicitudPageProps) => {


  const analisisCredito = hasPermission(PermissionsEnum.solicitud_tutor_descuento_accion_score_bajo)

  const {
    columnBase
  } = useTableColumnsSolicitudIngresoProspecto({
    estado_solicitud: estadoSolicitud,
  });

  const [tipoBeneficio, setTipoBeneficio] = useState<ITipoBeneficio | null>();

  const [observacionSolicitud, setObservacionSolicitud] = useState<{ [key: string]: string } | null>(null);

  const [open, setOpen] = useState<boolean>(false);
  const form = useForm<SolicitudTutorDescuentoForm>({
    resolver: yupResolver(newSolicitudIngresoBenificio as any)
  });

  const {
    handleSubmit,
    reset,
    control
    // formState: { errors },
  } = form;

  const { pagination, setPagination } = useTableFilter();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: supervicionRes,
    isRefetching,
  } = useGetSolicitudesTutorDescuento({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_solicitud: estadoSolicitud,
    ...filterObject,
    ...tipoBeneficio,
    filterByState: false,
  });

  const {
    mutate: updateSolicitudTutorDescuento
  } = useUpdateSolicitudTutorDescuento({});


  const [senalAlerta, setSenalAlerta] = useState<string | null>(null)

  const handleRevisarSolicitud = (data: SolicitudTutorDescuento) => {

    const {
      prospecto_data,
      id_solicitud_tutor_descuento,
      observaciones
    } = data;

    setObservacionSolicitud(observaciones ?? null)

    if (prospecto_data?.reportado
      && !hasPermission(PermissionsEnum.solicitud_beneficio_reportado_telco)) {
      return toast.info(
        "Acceso denegado. No cumples con los permisos necesarios [403]",
      );
    }

    if (prospecto_data?.es_reportado
      && !hasPermission(PermissionsEnum.solicitud_ingreso_score_bajo_reportado)) {
      return toast.info(
        "Acceso denegado. No cumples con los permisos necesarios [403]",
      );
    }

    if (prospecto_data?.es_ayuda_social
      && !hasPermission(PermissionsEnum.solicitud_ingreso_beneficio_ayuda_social)) {
      return toast.info(
        "Acceso denegado. No cumples con los permisos necesarios [403]",
      );
    }

    const {
      es_gremio,
      es_reportado,
      reportado,
      es_ayuda_social,
      es_bono_humano,
      es_curador_tutor,
    } = prospecto_data ?? {};

    const reglas: string[] = [];

    if (es_reportado) reglas.push(`• ${ReglasSolicitudBeneficioEnum.SCORE_BAJO}`);
    if (reportado) reglas.push(`• ${ReglasSolicitudBeneficioEnum.REPORTADA_TELCO}`);
    if (es_gremio) reglas.push(`• ${ReglasSolicitudBeneficioEnum.APLICA_GREMIO}`);
    if (es_ayuda_social) reglas.push(`• ${ReglasSolicitudBeneficioEnum.AYUDA_SOCIAL}`);
    if (es_bono_humano) reglas.push(`• ${ReglasSolicitudBeneficioEnum.BONO_DESARROLLO_HUMANO}`);
    if (es_curador_tutor) reglas.push(`• ${ReglasSolicitudBeneficioEnum.FAMILIAR_DISCAPACIDAD}`);

    //setSenalAlerta(reglas.join("\n"));
    setSenalAlerta(reglas.join("\n"));

    setOpen(true);

    reset({
      ...form.getValues(),
      ...data.prospecto_data,
      id_solicitud_tutor_descuento: id_solicitud_tutor_descuento,
      es_reportado: data.es_reportado,
      reportado: prospecto_data?.reportado,
      es_tutor: data.es_tutor || prospecto_data?.es_curador_tutor,
      observacion_solicitud: observaciones?.observacion_solicitud,
      observacion_supervisor: `${observaciones?.observacion_score_bajo ?? ''} ${observaciones?.observacion_reportado ?? ''}`,
      //observacion_score_bajo: observaciones?.observacion_score_bajo,
      //observacion_reportado: observaciones?.observacion_reportado,
      segmentacion: prospecto_data?.segmentacion,
    } as any);

  };


  function onChangeTipoBeneficio(value: string) {

    setPagination({
      pageIndex: 0,
      pageSize: 10
    })

    if (!value || value == TipoBeneficioENUM.TODOS) {
      setTipoBeneficio(null)
      return;
    }

    setTipoBeneficio({
      es_ayuda_social: value == TipoBeneficioENUM.AYUDA_SOCIAL ? true : null,
      es_bono_humano: value == TipoBeneficioENUM.DESARROLLO_HUMANO ? true : null,
      es_tutor: value == TipoBeneficioENUM.FAMILIAR_DISCAPACIDAD ? true : null,
      es_gremio: value == TipoBeneficioENUM.APLICA_GREMIO ? true : null,
      es_reportado: value == TipoBeneficioENUM.REPORTADO ? true : null, // Score bajo
      reportado: value == TipoBeneficioENUM.REPORTADO_TELCO ? true : null // Reportado por ISP
    })

  }


  return (
    <>
      <Grid container spacing={3}>
        <CustomAutocompleteArrStringNoForm
          required={false}
          size={gridSizeMdLg6}
          label="Tipo de Beneficio"
          defaultValue={ analisisCredito ? TipoBeneficioENUM.REPORTADO : "TODOS"}
          // options
          options={analisisCredito 
            ? TipoBeneficio.filter((item) => item === TipoBeneficioENUM.REPORTADO) 
            : TipoBeneficio}
          // validation
          onChangeValue={onChangeTipoBeneficio}
        />
        <Grid item xs={12}>
          <GeneralTable<SolicitudTutorDescuento>
            columns={columnBase}
            data={supervicionRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={supervicionRes?.data?.count}
            actionsColumnSize={120}
            onEdit={handleRevisarSolicitud}
            canDelete={false}
            positionActionsColumn="first"
            editIcon={<Visibility />}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            ///*
            canEdit={enableAction}
            enableColumnActions={enableAction}
            enableEditing={enableAction}
          />
        </Grid>
      </Grid>
      <ScrollableDialogProps
        onCloseIcon={() => setOpen(false)}
        open={open}
        title="Revisión de Solicitud"
        showConfirmBtn={(form.getValues('es_reportado')
          && analisisCredito)
          ? false
          : true
        }
        onConfirm={handleSubmit(async (row) => {
          updateSolicitudTutorDescuento({
            id: row.id_solicitud_tutor_descuento!,
            data: {
              observaciones: {
                ...observacionSolicitud,
                observacion_supervisor: form.getValues('observacion_supervisor') ?? ''
              },
              estado_solicitud:
                SolicitudTutorDescuentoEstadoSolicitudEnum.APROBADO,
            },
          });
          setOpen(false);
          reset({});
        })}
        confirmVariantBtn={"contained"}
        confirmTextBtn="Aprobar"
        showRejectBtn={
          (form.getValues('es_reportado')
            && analisisCredito)
            ? false
            : true
        }
        onReject={handleSubmit(async (row) => {
          updateSolicitudTutorDescuento({
            id: row.id_solicitud_tutor_descuento!,
            data: {
              observaciones: {
                ...observacionSolicitud,
                observacion_supervisor: form.getValues('observacion_supervisor') ?? ''
              },
              estado_solicitud:
                SolicitudTutorDescuentoEstadoSolicitudEnum.RECHAZADO,
            },
          });

          setOpen(false);
          reset({});
        })}
        onClose={() => {
          setOpen(false);
          reset({});
        }}
        contentNode={
          <>
            <Grid container spacing={3}>

              <Grid item {...gridSizeMdLg12}>

                <Alert severity="warning">
                  <AlertTitle>
                    Advertencia: El cliente aplica a los siguientes casos:
                  </AlertTitle>

                  <div style={{
                    whiteSpace: 'pre-line'
                  }}>
                    {senalAlerta}
                  </div>
                </Alert>
              </Grid>

              {/*Informacion de Personal */}

              <Grid item {...gridSizeMdLg12}
                display={'inline-flex'}
                alignItems={'center'}
              >

                <Icon sx={{ marginRight: 1 }}>
                  <Person color="info" />
                </Icon>

                <Typography
                  variant="subtitle1"
                >
                  Información Personal
                </Typography>

              </Grid>

              <CustomTextFieldNoForm
                disabled={true}
                label={"Razón Social"}
                defaultValue={form.getValues().razon_social}
                size={gridSizeMdLg12}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={"Identificación"}
                defaultValue={form.getValues().identificacion}
                size={gridSizeMdLg6}
              />

              <CustomTextFieldNoForm
                disabled={true}
                label={"Celular"}
                defaultValue={form.getValues().celular}
                size={gridSizeMdLg6}
              />

              {
                form.getValues().es_tutor && (
                  <>
                    <Grid item {...gridSizeMdLg12}
                      display={'inline-flex'}
                      alignItems={'center'}
                    >

                      <Icon sx={{ marginRight: 1 }}>
                        <People color="info" />
                      </Icon>

                      <Typography
                        variant="subtitle1"
                      >
                        Persona con Discapacidad
                      </Typography>

                    </Grid>

                    <CustomTextFieldNoForm
                      disabled={true}
                      label={"Nombre"}
                      defaultValue={form.getValues().razon_social_carga_personal}
                      size={gridSizeMdLg12}
                    />

                    <CustomTextFieldNoForm
                      disabled={true}
                      label={"Identificación"}
                      defaultValue={
                        form.getValues().identificacion_carga_personal
                      }
                      size={gridSizeMdLg12}
                    />

                  </>
                )
              }

              {form.getValues().es_reportado && (
                <>
                  {/*Informacion de equifax */}

                  <Grid item {...gridSizeMdLg12}
                    display={'inline-flex'}
                    alignItems={'center'}
                  >

                    <Icon sx={{ marginRight: 1 }}>
                      <CreditCardIcon color="info" />
                    </Icon>

                    <Typography
                      variant="subtitle1"
                    >
                      Información de Equifax
                    </Typography>

                  </Grid>

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Puntaje Score"}
                    defaultValue={form.getValues().puntaje_score}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Score Empresa"}
                    defaultValue={form.getValues().puntaje_score_empresa}
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Score Sobreendeudamiento"}
                    defaultValue={form.getValues().puntaje_score_sobreendeudamiento}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Segmentacion"}
                    defaultValue={form.getValues().segmentacion}
                    size={gridSizeMdLg6}
                  />

                  {/*Observacion del asesor */}

                  <Grid item {...gridSizeMdLg12}
                    display={'inline-flex'}
                    alignItems={'center'}
                  >

                    <Icon sx={{ marginRight: 1 }}>
                      <ArticleIcon color="info" />
                    </Icon>

                    <Typography
                      variant="subtitle1"
                    >
                      Observaciones
                    </Typography>

                  </Grid>

                  {
                    form.getValues().observacion_solicitud &&
                    <CustomTextAreaNoForm
                      required={false}
                      disabled={true}
                      label="Observación Asesor"
                      value={form.getValues().observacion_solicitud ?? ''}
                    />
                  }

                  <CustomTextArea
                    control={control}
                    typeOfEntry="observacion"
                    name="observacion_supervisor"
                    required={false}
                    label="Observación Supervisor"
                    error={form.formState.errors.observacion_supervisor}
                    helperText={form.formState.errors.observacion_supervisor?.message}
                  />

                </>
              )

              }

              {/*Documentos */}

              {
                (
                  form.getValues().es_gremio
                  || form.getValues().es_tutor
                ) && (

                  <>
                    <Grid item {...gridSizeMdLg12}
                      display={'inline-flex'}
                      alignItems={'center'}
                    >

                      <Typography
                        variant="subtitle1"
                      >
                        Documentos Solicitados
                      </Typography>

                    </Grid>

                    {
                      form.getValues().es_gremio && (
                        <>

                          <Grid {...gridSizeMdLg6} item>

                            <Typography
                              variant="subtitle2"
                              marginBottom={1}
                            >
                              Identificación Personal
                            </Typography>

                            <ImagesWithZoom
                              src={form.getValues().url_foto_identificacion_personal_gremio!}
                              alt="Identificación Personal"
                            />
                          </Grid>

                          <Grid {...gridSizeMdLg6} item>


                            <Typography
                              variant="subtitle2"
                              marginBottom={1}
                            >
                              Credencial Empresa
                            </Typography>

                            <ImagesWithZoom
                              src={form.getValues().url_foto_credencial_empresa!}
                              alt="Credencial Empresa"
                            />
                          </Grid>

                          {/* <Grid {...gridSizeMdLg6} item>
                            <Typography
                              variant="subtitle2"
                              marginBottom={1}
                            >
                              Documento Legal Empresa
                            </Typography>
                            <ImagesWithZoom
                              src={form.getValues().url_foto_documento_legal_empresa!}
                              alt="Documento Legal Empresa"
                            />
                          </Grid> */}
                        </>
                      )
                    }

                    {
                      form.getValues().es_tutor && (
                        <>

                          <Grid {...gridSizeConst6} item>

                            <Typography
                              variant="subtitle2"
                              marginBottom={1}
                            >
                              Tutor con Discapacidad
                            </Typography>

                            <ImagesWithZoom
                              src={form.getValues().url_foto_tutor_discapacidad!}
                              alt="Tutor con Discapacidad"
                            />
                          </Grid>
                          <Grid {...gridSizeConst6} item>

                            <Typography
                              variant="subtitle2"
                              marginBottom={1}
                            >
                              Documento Legal Representante
                            </Typography>

                            <ImagesWithZoom
                              src={
                                form.getValues()?.url_foto_documento_legal_representante!
                              }
                              alt="Documento Legal Representante"
                            />
                          </Grid>
                        </>
                      )
                    }


                  </>
                )
              }



            </Grid>
          </>
        }
      />
    </>
  );
};

export default SolicitudIngresoProspectoSolicitudPage;
